module.exports = __webpack_public_path__ + "static/media/Frame 2822.98f344db.jpg";